/**
 * Messages
 */
const messages = require('../../messages');

/**
 * Repositories
 */
const permissionIdentities = require('../../permission-identities');

/**
 * Request schemas
 */
const requestSchemas = require('../../request-schemas');

/**
 * Scopes
 */
const scopes = require('../../scopes');

module.exports = [
  {
    action: 'createCustomerDealSchedulesByDealId',
    message: messages.SUCCESS_CREATE_CUSTOMER_DEAL_SCHEDULE_BY_DEAL_ID,
    method: 'POST',
    path: '/customer/:customerId/deal-schedules/:dealId',
    payloadType: 'collection',
    permissionIdentity: permissionIdentities.CREATE_CUSTOMER_DEAL_SCHEDULE,
    requestSchema: requestSchemas.customerDealSchedules.createCustomerDealSchedulesByDealId,
  },
  {
    action: 'deleteCustomerDealSchedulesBySystemGameId',
    message: messages.SUCCESS_DELETE_CUSTOMER_DEAL_SCHEDULES_BY_SYSTEM_GAME_ID,
    method: 'DELETE',
    path: '/customer/:customerId/deal-schedules/:systemGameId',
    payloadType: 'collection',
    permissionIdentity: permissionIdentities.DELETE_CUSTOMER_DEAL_SCHEDULE,
    requestSchema: requestSchemas.customerDealSchedules.deleteCustomerDealSchedulesBySystemGameId,
  },
  {
    action: 'getCustomerDealSchedulesBySystemGameId',
    message: messages.SUCCESS_GET_CUSTOMER_DEAL_SCHEDULES_BY_SYSTEM_GAME_ID,
    method: 'GET',
    path: '/customer/:customerId/deal-schedules/:systemGameId',
    payloadType: 'collection',
    permissionIdentity: permissionIdentities.GET_CUSTOMER_DEAL_SCHEDULE,
    requestSchema: requestSchemas.customerDealSchedules.getCustomerDealSchedulesBySystemGameId,
    scopes: [scopes.DEFAULT],
  },
];
